mutation CreateContent($input: CreateContentInput!) {
  createContent(input: $input) {
    id
  }
}
